<!--sidebar-->
<div class="main-menu menu-fixed menu-dark menu-accordion menu-shadow" data-scroll-to-active="true">
  <div class="main-menu-content">
    <ul class="navigation navigation-main" id="main-menu-navigation mt-50" data-menu="menu-navigation">
      <li>
        <a class="menu-item" routerLinkActive="active" routerLink="/dashboard"><i class="fa fa-tachometer"
          aria-hidden="true"></i><span>Dashboard</span></a>
        </li>

        @if (details?.permission === 'super_admin') {
          <li>
            <a class="menu-item" routerLinkActive="active" routerLink="/agent"><i class="fa fa-building-o"
              aria-hidden="true"></i><span>IMTO Partner</span></a>
            </li>
          }
          @if (details?.permission === 'super_admin') {
            <li>
              <a class="menu-item" routerLinkActive="active" routerLink="/admin"><i class="fa fa-shield"
                aria-hidden="true"></i><span>Admin</span></a>
              </li>
            }
            <li>
              <a class="menu-item" routerLinkActive="active" routerLink="/transactions"><i class="fa fa-list-alt"
                aria-hidden="true"></i><span>Transaction Report</span></a>
              </li>
              <li>
                <a class="menu-item" routerLinkActive="active" routerLink="/dollar-rate"><i class="fa fa-usd"
                aria-hidden="true"></i><span>Daily Dollar Exchange
              Rate</span></a>
            </li>
            <li>
              <a class="menu-item" routerLinkActive="active" routerLink="/fund-history"><i class="fa fa-upload"
                aria-hidden="true"></i><span>Upload Fund History</span></a>
              </li>
              @if (details?.permission === 'super_admin') {
                <li>
                  <a class="menu-item" routerLinkActive="active" routerLink="/reconciliation"><i class="fa fa-balance-scale"
                    aria-hidden="true"></i><span>Reconciliation</span></a>
                  </li>
                }
                @if (
                  $safeNavigationMigration(details?.agent?.secret_key) !== null ||
                  $safeNavigationMigration(details?.agent?.public_key) !== null
                  ) {
                  <li>
                    <a class="menu-item" routerLinkActive="active" routerLink="/api-keys"><i class="fa fa-key"
                      aria-hidden="true"></i><span>API keys</span></a>
                    </li>
                  }
                  <!-- <li
        *ngIf="
          details?.permission === 'super_admin' &&
          (details?.email === 'tbamanga@entrustedltd.com' ||
            details?.email === 'ayodeji@ionec.com' ||
            details?.email === 'oolanrewaju@entrustedltd.com')
        "
                  >
                  <a
                    class="menu-item"
                    routerLinkActive="active"
                    routerLink="/transfer-commission"
                    ><i class="icons fa fa-exchange" aria-hidden="true"></i>Transfer
                    Commission</a
                    >
                  </li> -->
                  <li>
                    <a href="../../../../assets/file/Icashremit-User-Manual-V2.1.pdf" target="_blank" class="menu-item"><i
                      class="fa fa-book" aria-hidden="true"></i><span>Manual</span></a>
                    </li>
                    <li>
                      <a class="menu-item" href="#" (click)="logout($event)"><i class="fa fa-sign-out"
                        aria-hidden="true"></i><span>Logout</span></a>
                      </li>
                    </ul>
                  </div>
                </div>